export default "__VITE_ASSET__BPxzHx9___"